<template>
    <div class="sign-in">
		<a-row type="flex" :gutter="[24,24]" justify="space-around" align="middle" class="row-main">

			<!-- Sign IN Form Column -->
			<a-col :span="24" :md="{ span: 14, offset: 2 }" :lg="10" :xl="6" class="col-form mr-auto">
				<h4 class="mb-15">Sign In</h4>
				<p class="text-muted">Enter your username and password to sign in</p>

				<!-- Sign In Form -->
				<a-form-model
					id="login-form"
					ref="loginForm"
					:model="credentials"
					:rules="rules"
					class="login-form"
					:hideRequiredMark="true"
				>
					<a-form-model-item class="mb-10" label="Username" :colon="false" ref="userName" prop="userName">
						<a-input v-model="credentials.userName"
								 @blur="() => {$refs.userName.onFieldBlur();}"
								 placeholder="Name" />
					</a-form-model-item>
					<a-form-model-item class="mb-5" label="Password" :colon="false" ref="password" prop="password">
						<a-input  v-model="credentials.password"
								  @blur="() => {$refs.password.onFieldBlur();}"
								 type="password" placeholder="Password" />
					</a-form-model-item>
					
					<a-form-model-item>
						<a-button type="primary" block html-type="submit" class="login-form-button"
								  @click="handleSubmit"
						>
							SIGN IN
						</a-button>
					</a-form-model-item>
				</a-form-model>
				<!-- / Sign In Form -->

			</a-col>
			<!-- / Sign In Column -->

			<!-- Sign In Image Column -->
			<a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
				<div>
					<div class="img">
						<img src="@/assets/images/info-rocket-ill.png" alt="rocket">
					</div>
					<h4>{{ message }}</h4>
					<p class="text-white"></p>
				</div>
			</a-col>
			<!-- / Sign In Image Column -->

		</a-row>
		
	</div>
</template>

<script>
import  {HUB_CONNECTING_EVENT } from '../common/events/eventsSource.js'
export default {
	inject : ['eventBus'],

	data () {
		return {
			credentials: {
				userName : '',
				password : ''
			},
			message : '',
			rules : {
				userName: [
					{ required: true, message: 'Please enter your username', trigger: 'blur' },
					{ min: 6, message: 'Username is not valid', trigger: 'blur' }
				],
				password: [
					{ required: true, message: 'Please enter your password', trigger: 'blur' },
					{ min: 6, message: 'Password is not valid', trigger: 'blur' }
				]
			}

		}
	},
	methods : {
		handleSubmit() {
			this.$refs.loginForm.validate( async (valid) => {
				if(valid) {
					
					this.$message.loading('Login in...', 0);
					let result = await this.$store.dispatch('auth/loginAction', this.credentials);

					
					if (result.success) {
						//
						//Connect to instant message hub
						//
						
						this.$message.success('Login successfully!');
						
						this.eventBus.$emit(HUB_CONNECTING_EVENT, {});
						this.$router.push('/'); 

					}
					else {
						this.$message.error(result.message);
					}

				}
				else{
					console.log(' not valid')
				}

				this.$message.destroy();
			})
		},

		sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		}

	},
	
}
</script>
